import React from "react";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import kodexIcon from "../assets/kodex_icon.svg";

export default function LegalLayout({ title, updatedDate, children }) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/login");
        }
    };

    return (
        <Box
            sx={{
                bgcolor: "background.default",
                minHeight: "100dvh",
                py: { xs: 3, sm: 6 },
                px: 2,
            }}
        >
            <Box sx={{ maxWidth: 760, mx: "auto" }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
                    <Box component="img" src={kodexIcon} alt="Kodex" sx={{ height: 40, width: 40 }} />
                    <Button
                        size="small"
                        variant="text"
                        startIcon={<ArrowBackIcon fontSize="small" />}
                        sx={{ textTransform: "none", color: "text.secondary" }}
                        onClick={handleBack}
                    >
                        Back
                    </Button>
                </Stack>

                <Paper
                    elevation={0}
                    sx={{
                        border: "1px solid",
                        borderColor: "primary.main",
                        borderRadius: 1,
                        p: { xs: 2.5, sm: 4 },
                    }}
                >
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        sx={{ fontFamily: "Montserrat, sans-serif", mb: 0.5 }}
                    >
                        {title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 3 }}>
                        Last updated: {updatedDate}
                    </Typography>

                    <Box
                        sx={{
                            "& h2": {
                                fontFamily: "Montserrat, sans-serif",
                                fontSize: "1.05rem",
                                fontWeight: 700,
                                mt: 3,
                                mb: 1,
                            },
                            "& p, & li": {
                                fontSize: "0.9rem",
                                color: "text.secondary",
                                lineHeight: 1.7,
                            },
                            "& ul": { pl: 3, mb: 2 },
                            "& p": { mb: 2 },
                        }}
                    >
                        {children}
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
}
